import { useProjectTasksContext } from '../ProjectTasksContext';

export const useProjectTasksFilter = () => {
  const { searchCriteria: { keywords } = {} } = useProjectTasksContext();

  return keywords && keywords.length > 0 ? keywords.join(' ') : undefined;
};

export default useProjectTasksFilter;
